import React from 'react';

import { Typography } from 'antd';

import ColoredFormattedNumber from 'components/ColoredFormattedNumber';

interface SummaryBarProps {
  countLabel: string;
  totalLabel: string;
  totalValue: number;
  exportSlot?: React.ReactNode;
}

export function SummaryBar({ countLabel, totalLabel, totalValue, exportSlot }: SummaryBarProps) {
  return (
    <div id='report-summary-bar' className='mb-4 flex flex-wrap items-center justify-between gap-4'>
      <Typography.Text>
        {countLabel}
        <Typography.Text type='secondary'> · </Typography.Text>
        {totalLabel}:{' '}
        <Typography.Text strong>
          <ColoredFormattedNumber value={totalValue} format='BRL' />
        </Typography.Text>
      </Typography.Text>
      {exportSlot}
    </div>
  );
}

export default SummaryBar;
